import { GET_AUTHENTICATE, POST_REFRESH, GET_VALIDATE, GET_LOGOUT } from '../../common/constants/constants';
import { JWTAuthenticateRequest, JWTRefreshRequest } from '../../common/types/requestTypes';
import axiosApi from '../../api/axiosApi';
class JWTTokenService {
  getToken(email: String, password: String) {
    return axiosApi.post(GET_AUTHENTICATE, {
      username: email,
      password: password,
    } as JWTAuthenticateRequest);
  }
  refreshToken(accessToken: String, refreshToken: String) {
    return axiosApi.post(POST_REFRESH, {
      accessToken: accessToken,
      refresh: refreshToken,
    } as JWTRefreshRequest);
  }
  validateToken() {
    return axiosApi.get(GET_VALIDATE);
  }
  logout() {
    return axiosApi.get(GET_LOGOUT);
  }
}

export default new JWTTokenService();
